import type React from 'react'

type TabListKeyDownOptions<T extends string> = {
  tabs: readonly T[]
  activeTab: T
  setActiveTab: (tab: T) => void
  tabElementIds: Record<T, string>
}

// ARIA APG tab pattern: ArrowLeft/Up = previous, ArrowRight/Down = next
// (both cyclic), Home = first, End = last. Updates the active tab and
// moves DOM focus to the newly-active tab button so keyboard users stay
// in sync with state.
export function handleTabListKeyDown<T extends string>(
  event: React.KeyboardEvent,
  options: TabListKeyDownOptions<T>
): void {
  const { tabs, activeTab, setActiveTab, tabElementIds } = options
  const currentIndex = tabs.indexOf(activeTab)
  let nextIndex: number | null = null

  switch (event.key) {
    case 'ArrowRight':
    case 'ArrowDown':
      nextIndex = (currentIndex + 1) % tabs.length
      break
    case 'ArrowLeft':
    case 'ArrowUp':
      nextIndex = (currentIndex - 1 + tabs.length) % tabs.length
      break
    case 'Home':
      nextIndex = 0
      break
    case 'End':
      nextIndex = tabs.length - 1
      break
    default:
      return
  }

  event.preventDefault()
  const nextTab = tabs[nextIndex]
  setActiveTab(nextTab)
  document.getElementById(tabElementIds[nextTab])?.focus()
}
